







































import AltiWindsView from '@/components/alti-winds-view'
import SoundingView from '@/components/sounding-view'
// import TourOfEurope from '@/components/tour-of-europe'
// import { SwipeDetector } from 'swipedetector'
import throttle from 'lodash/throttle'

export default {
  name: 'right-tabs',
  components: { AltiWindsView, SoundingView },
  data() {
    return {
      tab: 0,
      tabCount: 2
    }
  },
  props: [
    'redraw'
  ],
  computed: {
    windUnit: {
      set(val) {
        this.$store.dispatch('persistent/setWindUnit', val)
      },
      get() {
        return this.$store.state.persistent.windUnit
      }
    }
  },
  mounted() {
    this.$refs.header.addEventListener('wheel', throttle(this.scrollTab, 300))
    // const swipe = new SwipeDetector(this.$el).emitter
    // swipe.on('up', () => {
    //   this.close()
    // })
    // swipe.on('down', () => {
    //  this.swipeTab(1)
    // })
  },
  methods: {
    close() {
      this.$emit('close-details')
    },
    swipeTab(distance) {
      let tab = this.tab + distance
      tab %= this.tabCount
      if (tab < 0) tab += this.tabCount
      this.tab = tab
    },
    scrollTab(e) {
      if (e.deltaY < 0) {
        this.swipeTab(-1)
      } else if (e.deltaY > 0) {
        this.swipeTab(1)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/right-tabs.vue